import { render, staticRenderFns } from "./CreateButton.vue?vue&type=template&id=6ea4529a&scoped=true&"
import script from "./CreateButton.vue?vue&type=script&lang=ts&"
export * from "./CreateButton.vue?vue&type=script&lang=ts&"
import style0 from "./CreateButton.vue?vue&type=style&index=0&id=6ea4529a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea4529a",
  null
  
)

export default component.exports